import { format } from 'date-fns';


export function isNotNull (value) {
  return value !== undefined && value !== null;
}

export function isArray (value) {
  return value !== null && value !== undefined && Array.isArray(value);
}

export function isNotEmptyObject (value) {
  return (
    value !== null &&
    value !== undefined &&
    Object.keys(value).length !== 0 &&
    Object.getPrototypeOf(value) === Object.prototype
  );
}

export function isEqual (item, value) {
  if (value !== null || value !== undefined) {
    return item == value;
  }
  return false;
}

export function includesText (item, value) {
  if (value !== null || value !== undefined) {
    return item.toLowerCase().includes(value.toLowerCase());
  }
  return false;
}

export function isBigger (item, value) {
  if (value !== null || value !== undefined) {
    return item > parseFloat(value);
  }
  return false;
}

export function isSmaller (item, value) {
  if (value !== null || value !== undefined) {
    return item < parseFloat(value);
  }
  return false;
}

export function isExactly (item, value) {
  if (value !== null || value !== undefined) {
    return item == parseFloat(value);
  }
  return false;
}

export function fixedPosition(number, position) {
  if (typeof number != 'number') {
    return number;
  }
  return parseFloat(number.toFixed(position));
}

export function arraysEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a == null || b == null) {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}


export function getDateFormatted(date) {
  try {
    return format(new Date(date), 'dd/MM/yyyy HH:mm');
  } catch (err) {
    return '--';
  }
}

export function capitalize(word) {
  if (!isNotNull(word)) return '--';
  return word[0].toUpperCase() + word.slice(1);
}

export function debounce(fn, wait){
  let timer;
 return function(...args){
   if(timer) {
      clearTimeout(timer);
   }
   const context = this;
   timer = setTimeout(()=>{
      fn.apply(context, args);
   }, wait);
 }
}

export function loadStoredFilters(prodType, state, STORAGE_KEY) {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  const parsed = JSON.parse(raw);
  return parsed?.[prodType]?.[state] ?? null;
}

export function saveStoredFilters(prodType, state, partialData, key = 'trinovati_filters') {
  const raw = localStorage.getItem(key);
  const parsed = raw ? JSON.parse(raw) : {};

  if (!parsed[prodType]) parsed[prodType] = {};
  if (!parsed[prodType][state]) parsed[prodType][state] = {};

  const existingData = { ...parsed[prodType][state] };

  if (partialData.property_filters) {
    const existingFilters = existingData.property_filters || [];
    const combined = [...existingFilters, ...partialData.property_filters];
    const uniqueFilters = combined.filter((filter, index, self) =>
      index === self.findIndex(f =>
        f.field === filter.field &&
        f.operator === filter.operator &&
        JSON.stringify(f.value) === JSON.stringify(filter.value)
      )
    );

    existingData.property_filters = uniqueFilters;
  }

  for (const key in partialData) {
    if (key !== 'property_filters') {
      existingData[key] = partialData[key];
    }
  }

  parsed[prodType][state] = existingData;
  localStorage.setItem(key, JSON.stringify(parsed));
}

export function removeStoredFilters(prodType, state, field, key = 'trinovati_filters') {
  const raw = localStorage.getItem(key);
  if (!raw) return;

  const parsed = JSON.parse(raw);

  if (
    !parsed[prodType] ||
    !parsed[prodType][state] ||
    !Array.isArray(parsed[prodType][state].property_filters)
  ) {
    return;
  }

  const newFilters = parsed[prodType][state].property_filters.filter(
    (filter) => filter.field !== field
  );

  parsed[prodType][state].property_filters = newFilters;

  localStorage.setItem(key, JSON.stringify(parsed));
}

export function formatDuration(duration) {
  if (!duration || typeof duration !== 'string') return '-';

  const parts = [];

  const match = {
    years: duration.match(/Y(\d+)/i)?.[1],
    months: duration.match(/M(?![a-z])(\d+)/i)?.[1],
    days: duration.match(/D(\d+)/i)?.[1],
    hours: duration.match(/H(\d+)/i)?.[1],
    minutes: duration.match(/m(\d+)/i)?.[1],
    seconds: duration.match(/S(\d+)/i)?.[1],
  };

  if (match.years) parts.push(`${match.years} ano${match.years === '1' ? '' : 's'}`);
  if (match.months) parts.push(`${match.months} mês${match.months === '1' ? '' : 'es'}`);
  if (match.days) parts.push(`${match.days} dia${match.days === '1' ? '' : 's'}`);
  if (match.hours) parts.push(`${match.hours} hora${match.hours === '1' ? '' : 's'}`);
  if (match.minutes) parts.push(`${match.minutes} minuto${match.minutes === '1' ? '' : 's'}`);
  if (match.seconds) parts.push(`${match.seconds} segundo${match.seconds === '1' ? '' : 's'}`);

  return parts.length ? parts.join(', ') : '-';
}

export function validateDocument(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let sum = 0, rem;
  for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  rem = (sum * 10) % 11;
  if (rem >= 10) rem = 0;
  if (rem !== parseInt(cpf.substring(9, 10))) return false;
  sum = 0;
  for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  rem = (sum * 10) % 11;
  if (rem >= 10) rem = 0;
  return rem === parseInt(cpf.substring(10, 11));
}

